module.exports = __webpack_public_path__ + "img/team.47d6c1b5.jpg";